import { render, staticRenderFns } from "./PermissionsEdit.vue?vue&type=template&id=fd8ef4bc&scoped=true"
import script from "./PermissionsEdit.vue?vue&type=script&lang=js"
export * from "./PermissionsEdit.vue?vue&type=script&lang=js"
import style0 from "./PermissionsEdit.vue?vue&type=style&index=0&id=fd8ef4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8ef4bc",
  null
  
)

export default component.exports